import { render } from "./Flex.vue?vue&type=template&id=07c2e574&scoped=true"
import script from "./Flex.vue?vue&type=script&lang=js"
export * from "./Flex.vue?vue&type=script&lang=js"

import "./Flex.vue?vue&type=style&index=0&id=07c2e574&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07c2e574"

export default script